<script>export let disabled = false;
export let type = "button";
export let story = void 0;
export let tab = true;
$:
  storyClasses = (story ?? "primary.medium").split(".");
$: {
  if (storyClasses[storyClasses.length - 1] === "disabled") {
    storyClasses.splice(storyClasses.length - 1, 1);
    disabled = true;
  }
}
const setType = (node) => {
  node.type = type;
};
</script>

<button tabindex="{tab ? 0 : -1}" {disabled} use:setType class="button {storyClasses.join(' ')}" on:click
	><slot><span class="glyph-user" /><span>My Icon Button</span></slot></button
>

<style>
  .button {
    --typography-font: 400 1rem/1.2 "Roboto";
    --typography-font-size: 1rem;
    --typography-line-height: 1.2;
    --typography-letter-spacing: 0.0625rem;
    --text-color: #1A1B1F;
    --disabled-text-color: #2D2F36;
    --border-color: #6BAE85;
    --hover-border-color: #4b7a5d;
    --active-border-color: transparent;
    --focus-border-color: #1A1B1F;
    --disabled-border-color: #46464A;
    --fill: #6BAE85;
    --hover-fill: #4b7a5d;
    --active-fill: #4b7a5d;
    --focus-fill: #6BAE85;
    --disabled-fill: #46464A;
    --border-radius: 0.25rem;
    --item-spacing: 0.5rem;
    --border-width: 0.125rem;
    --padding-horizontal: 1.5rem;
    --padding-vertical: 0.75rem;
    --min-width: 3rem;
    --max-width: 12rem;
    --min-height: 2.5rem;
    --max-height: 2.5rem;
    --active-box-shadow: inset 0.0625rem 0.0625rem 0.3125rem 0rem #1A1B1F;
    --focus-box-shadow: 0.0625rem 0.0625rem 0.3125rem 0rem #1A1B1F;
  }

  .primary {
    --text-color: #1A1B1F;
    --disabled-text-color: #2D2F36;
    --fill: #6BAE85;
    --focus-fill: #6BAE85;
    --disabled-fill: #46464A;
    --hover-border-color: #46464A;
  }

  .secondary {
    --text-color: #6BAE85;
    --disabled-text-color: #46464A;
    --fill: transparent;
    --focus-fill: #4b7a5d;
    --disabled-fill: transparent;
    --hover-border-color: transparent;
  }

  .medium {
    --typography-font: 400 1rem/1.2 "Roboto";
    --typography-font-size: 1rem;
    --typography-line-height: 1.2;
    --typography-letter-spacing: 0.0625rem;
    --item-spacing: 0.5rem;
    --padding-horizontal: 1.5rem;
    --padding-vertical: 0.75rem;
  }

  .small {
    --typography-font: 400 0.875rem/1.2 "Roboto";
    --typography-font-size: 0.875rem;
    --typography-line-height: 1.2;
    --typography-letter-spacing: 0.0625rem;
    --item-spacing: 0.25rem;
    --padding-horizontal: 0.75rem;
    --padding-vertical: 0.5rem;
  }

  .icon {
    --fill: transparent;
    --focus-fill: transparent;
    --disabled-fill: transparent;
    --hover-border-color: transparent;
    --border-color: transparent;
    --active-border-color: transparent;
    --focus-border-color: transparent;
    --disabled-border-color: transparent;
    --hover-fill: transparent;
    --active-fill: transparent;
  }

	button {
		border-radius: var(--border-radius);
		outline: 0;
		border-width: var(--border-width);
		border-style: solid;
		padding: var(--padding-vertical) var(--padding-horizontal);
		min-width: var(--min-width);
		max-width: var(--max-width);
		min-height: var(--min-height);
		max-height: var(--max-height);
		font: var(--typography-font);
		display: inline-flex;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;
		gap: var(--item-spacing);
		cursor: pointer;
	}

	button {
		color: var(--text-color);
		background-color: var(--fill);
		border-color: var(--border-color);
	}

	button.hover,
	button:hover {
		color: var(--text-color);
		background-color: var(--hover-fill);
		border-color: var(--hover-border-color);
	}

	button.focus,
	button:focus {
		color: var(--text-color);
		background-color: var(--focus-fill);
		border-color: var(--focus-border-color);
		box-shadow: var(--focus-box-shadow);
	}

	button.active,
	button:active {
		color: var(--text-color);
		background-color: var(--active-fill);
		border-color: var(--active-border-color);
		box-shadow: var(--active-box-shadow);
	}

	button:disabled {
		color: var(--disabled-text-color);
		background-color: var(--disabled-fill);
		border-color: var(--disabled-border-color);
		cursor: unset;
		box-shadow: none;
	}
</style>
